export default __webpack_public_path__ + "static/media/0017.837f9a74.svg";